export class ActiveDirectoryUserAttribute {
  constructor(public readonly name: string, private _userAttributes: string[]) {}

  public get userAttributes(): string[] {
    return this._userAttributes.map(
      (userAttribute: string): string => `{UserAttr.${userAttribute}}`
    );
  }
}
